import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { A11y, Navigation, Pagination } from "swiper/core";
import { array, number, string } from "prop-types";
import useMatchMedia from "../../common/useMatchMedia.js";
import { useEffect, useState } from "react";

import StyledLink from "../StyledLink/StyledLink.jsx";
import ExecEdProgramCard from "../ExecEdProgramCard/ExecEdProgramCard.jsx";

const propTypes = {
  title: string,
  index: number,
  cards: array,
};

const FeaturedPrograms = (props) => {
  const { title, cards, index } = props;

  // For keeping track of whether we are in mobile view;
  // determines if carousel will be displayed
  const matchesMobile = useMatchMedia("(max-width: 1023px)");

  const [renderSwiper, setRenderSwiper] = useState(false);
  useEffect(() => {
    //required to let text load and prevent swiper init errors
    setRenderSwiper(true);
  }, []);

  SwiperCore.use([A11y, Pagination, Navigation]);

  return (
    cards.length > 0 && (
      <section className="featured-programs component">
        <div className="container container--100">
          <h2 className="featured-programs__title">{title}</h2>
          <div className="featured-programs__cards-container">
            {/* We only want to render a carousel when 
              we are in mobile view, and there is 
              more than 1 featured program to display */}
            {matchesMobile && cards.length > 1 ? (
              <div className="featured-programs__swiper">
                {renderSwiper && (
                  <Swiper
                    a11y
                    observer={true}
                    observeParents={true}
                    navigation={
                      cards.length > 1
                        ? {
                            prevEl: `.featured-programs__prev-${index}`,
                            nextEl: `.featured-programs__next-${index}`,
                          }
                        : false
                    }
                    pagination={{ clickable: true }}
                    slidesPerView={1}
                    spaceBetween={30}
                  >
                    {cards.map((card) => (
                      <SwiperSlide key={card.key}>
                        <ExecEdProgramCard {...card} equalHeights />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </div>
            ) : (
              cards?.map((card) => (
                <ExecEdProgramCard key={card.key} {...card} />
              ))
            )}
          </div>
        </div>
      </section>
    )
  );
};

FeaturedPrograms.propTypes = propTypes;
export default FeaturedPrograms;
